var path = '/modules/core/components/al-selectize/component.tpl.html';
var html = "<div class=\"al-selectize\">\n    <select></select>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/core/components/al-selectize/component.tpl.html
// module id = 2090
// module chunks = 1